(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[898],{

/***/ 7061:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/storelocator",
      function () {
        return __webpack_require__(7548);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 7548:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Storelocator; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7294);




function Storelocator() {
    const iframeRef = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)();
    const [basket, setBasket] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)();
    const [lang, setLang] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)("");
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(()=>{
        const baskets = window.sessionStorage.getItem("basketInfo");
        if (!baskets) {
            router.push("/baskets");
        }
    }, [
        router
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(()=>{
        const topLevelDomain = window.location.hostname.split(".").pop();
        setLang(topLevelDomain === "es" ? "es" : "fr");
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(()=>{
        setBasket(JSON.parse(sessionStorage.getItem("basketInfo")));
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(()=>{
        if (iframeRef.current && basket) {
            iframeRef.current.contentWindow.postMessage(basket, "".concat("https://locator.benebono", ".").concat(lang));
        }
    }, [
        basket,
        lang
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                    children: "Bene Bono"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("iframe", {
                id: "test",
                ref: iframeRef,
                style: {
                    display: "block",
                    minHeight: "100vh",
                    border: "none",
                    overflow: "hidden"
                },
                height: "100%",
                width: "100%",
                src: "".concat("https://locator.benebono", ".").concat(lang, "?basket=").concat(encodeURIComponent(JSON.stringify(basket))),
                // src={`http://localhost:3002?basket=${encodeURIComponent(
                //   JSON.stringify(basket)
                // )}`}
                onLoad: ()=>iframeRef.current.contentWindow.postMessage(basket, "".concat("https://locator.benebono", ".").concat(lang))
            })
        ]
    });
}


/***/ }),

/***/ 9008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(3121)


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [774,888,179], function() { return __webpack_exec__(7061); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);